import React, { useEffect, useState } from "react";
import HeadingComp from "../UdsEmployeeDashboard/CustomHooks/HeadingComp";
import { useSelector } from "react-redux";
import Select from "react-select";
// import "../../../StyleSheet/Mainstylesheet/Leave/LeaveApply.scss";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Checkbox from "@mui/material/Checkbox";
import { TextFields } from "@material-ui/icons";
import TextField from "@mui/material/TextField";
import fileUpload from "../../../../Assets/MainComponent/fileUpload.svg";

function PermissionApply() {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const leaveTypes = useSelector((state) => state.LeaveTypeData.LeaveTypeData);
  const leaveTypeOptions = leaveTypes.map((item) => ({
    value: item.id,
    label: item.leave_type,
  }));
  leaveTypeOptions.unshift({
    value: "",
    label: "Select type of leave",
    isDisabled: true,
  });

  const [data, setData] = useState({
    checked: false,
    leaveType: "",
    leaveDate: "",
    from_date: "",
    to_date: "",
    status: "pending",
    notes: "",
    user_id: "",
    request_type: "",
    leave_type: "",
  });
  const [error, setError] = useState({
    leaveType: false,
    leaveDate: false,
    from_date: false,
    to_date: false,
  });
  const [selectedLeave, setSelectedLeave] = useState({});
  const leaveOptions = [
    { value: "", label: "Select type of leave", isDisabled: true },
    { value: "casualLeave", label: "Casual Leave" },
    { value: "sickLeave", label: "Sick Leave" },
  ];
  const handleSubmit = (e) => {
    console.log("yeeee");
    e.preventDefault();
  };

  useEffect(() => {
    console.log(data, "datadatadata");
  }, [data]);
  useEffect(() => {
    console.log(leaveTypes, "ddddasdasfasdfasfasdf");
  }, [leaveTypes]);

  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const handleDate = (inputDate, name) => {
    const value = formatDate(inputDate);
    setData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const [selectedImage, setSelectedImage] = useState(null);
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
  };
  return (
    <div className={stateDisplay ? "outterContent" : "inner-Content"}>
      <div className="leaveApplyWrapper">
        <HeadingComp english={"Apply Leave"} hindi={"no Apply"} />
        <form onSubmit={handleSubmit}>
          <div className="leaveApplyBody">
            <div className="row">
              <div className="col-xl-6 col-md-12 section1">
                <label htmlFor="leaveType">
                  Leave Type<span style={{ color: "red" }}>*</span>
                </label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  defaultValue={leaveTypeOptions[0]}
                  isSearchable={true}
                  id="leaveType"
                  options={leaveTypeOptions}
                  onChange={(e) => {
                    setData((prev) => ({
                      ...prev,
                      leaveType: e.id,
                    }));
                    setSelectedLeave((prev) => ({
                      ...prev,
                      leaveType: e.label,
                    }));
                  }}
                />

                <div className="errorCheckBox">
                  {error.leaveType && <p>Leave type must be selected.</p>}
                </div>
              </div>
            </div>
            <>
              {!data.checked && (
                <div className="row ">
                  <div className="col-xl-6 col-md-12 section1">
                    <label className="col-12 p-0" htmlFor="leaveDate">
                      Leave Date<span style={{ color: "red" }}>*</span>
                    </label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        style={{ width: "100%" }}
                        onChange={(e) => {
                          handleDate(e?.$d, "leaveDate");
                        }}
                      />
                    </LocalizationProvider>
                    {error.leaveDate && <p>Leave date must be selected.</p>}
                  </div>
                </div>
              )}

              {data.checked && (
                <>
                  <div className="row ">
                    <div className="col-xl-6 col-md-12 section1">
                      <label className="col-12 p-0" htmlFor="leaveDate">
                        {" "}
                        Leave Date
                      </label>
                      <label className="col-12 p-0" htmlFor="leaveDate">
                        {" "}
                        From<span style={{ color: "red" }}>*</span>
                      </label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          value={data.from_date}
                          onChange={(e) => {
                            handleDate(e?.$d, "from_date");
                          }}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </LocalizationProvider>
                      {error.from_date && (
                        <p>From Leave date must be selected.</p>
                      )}
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-xl-6 col-md-12 section1">
                      <label className="col-12 p-0" htmlFor="leaveDate">
                        {" "}
                        To<span style={{ color: "red" }}>*</span>
                      </label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          value={data.to_date}
                          onChange={(e) => {
                            handleDate(e?.$d, "to_date");
                          }}
                        />
                      </LocalizationProvider>
                      {error.to_date && <p>To leave date must be selected.</p>}
                    </div>
                  </div>
                </>
              )}
              <div className="row ">
                <div className="col-xl-6 col-md-12 section1">
                  <Checkbox
                    checked={data.checked}
                    onChange={(event) => {
                      setData((prev) => ({
                        ...prev,
                        checked: event.target.checked,
                      }));
                    }}
                    label="Required"
                    sx={{
                      color: "#f26639",
                      "&.Mui-checked": {
                        color: "#f26639",
                      },
                    }}
                  />
                  <label
                    className=" p-0"
                    htmlFor="leaveDate"
                    style={{
                      color: "#f26639",
                      margin: "0",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setData((prev) => ({
                        ...prev,
                        checked: !data.checked,
                      }));
                    }}
                  >
                    {" "}
                    Continue Leaves
                  </label>
                </div>
              </div>
              <div className="row ">
                <div className="col-xl-12 col-md-12 section1">
                  <label
                    className=" p-0"
                    htmlFor="leaveDate"
                    style={{ color: "#f26639", margin: "0" }}
                  >
                    {" "}
                    Notes<span style={{ color: "red" }}>*</span>
                  </label>
                </div>
                <div className="col-xl-6 col-md-12 section1">
                  <textarea
                    style={{ width: "100%", height: "200px" }}
                  ></textarea>
                </div>
              </div>
              {selectedLeave.leaveType == "Medical Leave" && (
                <>
                  {selectedImage ? (
                    <div className="row d-flex justify-content-start">
                      <div className="col-xl-6 col-md-12 medicalImageWrapper">
                        <div className="medicalImageSection">
                          {/* <i
                            className="bi bi-pencil-square"
                            style={{ cursor: "pointer", color: "white" }}
                            fill="white"
                          ></i> */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="white"
                            class="bi bi-pencil-square"
                            viewBox="0 0 16 16"
                          >
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                            <path
                              fill-rule="evenodd"
                              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                            />
                          </svg>
                          <input type="file" onChange={handleFileSelect} />
                        </div>
                        <img
                          src={URL?.createObjectURL(selectedImage)}
                          alt="Selected"
                          style={{ width: "200px", height: "200px" }}
                        />
                        {/* <img src="" alt="Selected" style={{}} /> */}
                      </div>
                    </div>
                  ) : (
                    <div className="row medicalWrapper">
                      <div className="col-xl-6 col-md-12 medicalSection">
                        <label htmlFor="leaveType">
                          Upload Medical Certificate
                        </label>
                        <div className="fileUploadImg">
                          <img
                            src={fileUpload}
                            alt="fileUpload"
                            width={"40px"}
                            height={"40px"}
                          />
                        </div>

                        <input type="file" onChange={handleFileSelect} />
                      </div>
                    </div>
                  )}
                </>
              )}
              <div className="row ">
                <div className="col-xl-6 col-md-12 section1 d-flex justify-content-end">
                  <button className="customButton">Apply</button>
                </div>
              </div>
            </>
          </div>
        </form>
        {/* <TestCal /> */}
      </div>
    </div>
  );
}

export default PermissionApply;